<script lang="ts" setup="">
const {
  modelText,
  disabled = false,
  hasErrors = false,
} = defineProps<{
  modelText: string | null
  disabled?: boolean
  hasErrors?: boolean
}>()
</script>

<template>
  <span
    data-test="activator-value"
    :class="{
      'text-general-tertiary': !modelText && !hasErrors,
      'text-general-primary': !!modelText,
      'text-disabled-medium': disabled,
    }"
    class="truncate pr-3"
  >
    <slot />
  </span>
</template>
